import WasmController from "react-lib/frameworks/WasmController";
import * as SetPatient from "./sequence/SetPatient";
import * as CreateUpdateEncounter from "./sequence/CreateUpdateEncounter";
import * as SetCoverage from "./sequence/SetCoverage";
import * as EpisodeOfCare from "./sequence/EpisodeOfCare";
import * as MergePatient from "./sequence/MergePatient";

import EncounterDetail from "issara-sdk/apis/EncounterDetail_core";
import BuyerEncounterView from "issara-sdk/apis/BuyerEncounterView_core";

import { SetErrorMessage } from "../common/CommonInterface";

// Config
import CONFIG from "config/config";

export type Props = {

}

export type State = {} & SetPatient.State &
  CreateUpdateEncounter.State &
  SetCoverage.State &
  EpisodeOfCare.State &
  MergePatient.State;

export const StateInitial: State = {
  // ...SetPatient.StateInitial,
  // ...CreateUpdateEncounter.StateInitial,
  // ...SetCoverage.StateInitial,
  // ...MergePatient.StateInitial,
};

export type Event =
  | { message: "UpdateEncounterDetail"; params: {} }
  | { message: "HandleCreateBuyerEncounter"; params: {} }
  | SetPatient.Event
  | CreateUpdateEncounter.Event
  | SetCoverage.Event
  | EpisodeOfCare.Event
  | MergePatient.Event;

export type Data = {
  division?: number;
  device?: number;
} & SetPatient.Data &
  CreateUpdateEncounter.Data &
  SetCoverage.Data &
  EpisodeOfCare.Data &
  MergePatient.Data;

export const DataInitial = {
  ...SetPatient.DataInitial,
  ...CreateUpdateEncounter.DataInitial,
  ...SetCoverage.DataInitial,
  ...EpisodeOfCare.DataInitial,
  ...MergePatient.DataInitial,
};

type Handler = (
  controller: WasmController<State, Event, Data, Props>,
  params?: any
) => any;

const SUPPLY_ICONS = {
  appointment_or_cancel: "./static/images/order_images/supply.png",
  pending: "./static/images/order_images/supply_pending.png",
  performed: "./static/images/order_images/supply_performed.png",
};

export const DRUG_ICONS = {
  appointment_or_cancel: "./static/images/order_images/medication.png",
  pending: "./static/images/order_images/medication_pending.png",
  performed: "./static/images/order_images/medication_performed.png",
  // intratelephar
  none: {
    idle: "/static/images/intratelephar/home-opd.png",
    call: "/static/images/intratelephar/home-opd-calling.png",
    finish: "/static/images/intratelephar/home-opd-performed.png",
  },
  intra: {
    idle: "/static/images/intratelephar/intra-telephar.png",
    call: "/static/images/intratelephar/intra-telephar-calling.png",
    telelift:
      "/static/images/intratelephar/intra-telephar-transport-telelift.png",
    tele_idle: "/static/images/intratelephar/call-intra-telephar.png",
    tele_call: "/static/images/intratelephar/call-intra-telephar-calling.png",
    finish: "/static/images/intratelephar/intra-telephar-performed.png",
  },
  delivery: {
    idle: "/static/images/intratelephar/home-delivery.png",
    call: "/static/images/intratelephar/home-delivery-calling.png",
    finish: "/static/images/intratelephar/home-delivery-performed.png",
  },
};

export const DRUG_LIST_ISOLATED_ICON = CONFIG.ENABLE_INTRA_TELEPHAR
  ? ["drugopdhomeorder", "drugstatorder", "drugonedoseorder"]
  : [];

export const DOCTOR_ORDER_ACTION_MAP = {
  appointment_or_cancel: ["APPOINTMENT", "CANCEL"],
  pending: ["PENDING"],
  performed: ["PERFORMED"],
  inprogress: ["INPROGRESS"],
};

export const TELEPHAR_ACTION_MAP = {
  idle: ["IDLE"],
  call: ["CALLING", "ON_CALL"],
  tele_idle: ["TELE_IDLE"],
  tele_call: ["TELE_CALLING", "TELE_ON_CALL"],
  finish: ["FINISH", "TELE_FINISH"],
};

export const DOCTOR_ORDER_MAPPING_ICON = {
  drug: DRUG_ICONS,
  // drugstatorder: DRUG_ICONS,
  // drugonedoseorder: DRUG_ICONS,
  // drugopdhomeorder: {},
  treatmentorder: {
    appointment_or_cancel: "./static/images/order_images/treatment.png",
    pending: "./static/images/order_images/treatment_pending.png",
    performed: "./static/images/order_images/treatment_performed.png",
  },
  centrallaborder: {
    appointment_or_cancel: "./static/images/order_images/lab.png",
    pending: "./static/images/order_images/lab_pending.png",
    performed: "./static/images/order_images/lab_performed.png",
  },
  doctorconsultorder: {
    appointment: "./static/images/order_images/consult.png",
    pending: "./static/images/order_images/consult_pending.png",
    performed: "./static/images/order_images/consult_performed.png",
    cancel: "./static/images/order_images/consult_cancel.png",
    loading: "./static/images/order_images/consult_loading.png",
  },
  imagingorder: {
    appointment_or_cancel: "./static/images/order_images/xray.png",
    pending: "./static/images/order_images/xray_pending.png",
    inprogress: "./static/images/order_images/xray_inprogress.png",
    performed: "./static/images/order_images/xray_performed.png",
  },
  operatingorder: {
    appointment_or_cancel: "./static/images/order_images/or.png",
    pending: "./static/images/order_images/or_pending.png",
    performed: "./static/images/order_images/or_performed.png",
  },
  anesthesiaorder: {
    appointment_or_cancel: "./static/images/order_images/ane.png",
    pending: "./static/images/order_images/ane_pending.png",
    performed: "./static/images/order_images/ane_performed.png",
  },
  supply: SUPPLY_ICONS, // * supply ใช้ icon เดียวกัน ไม่ต้องระบุ supplyonedayorder กับ supplyopdhomeorder
  // supplyonedayorder: SUPPLY_ICONS,
  // supplyopdhomeorder: SUPPLY_ICONS,
  admitorder: {
    appointment_or_cancel: "./static/images/order_images/admission.png",
    pending: "./static/images/order_images/admission_pending.png",
    performed: "./static/images/order_images/admission_performed.png",
  },
  doctornoteorder: {
    appointment_or_cancel: "./static/images/order_images/drnoteorder.png",
    pending: "./static/images/order_images/drnoteorder_pending.png",
    performed: "./static/images/order_images/drnoteorder_performed.png",
  },
  rehabilitationorder: {
    appointment_or_cancel: "./static/images/order_images/rehabilitation.png",
    pending: "./static/images/order_images/rehabilitation_pending.png",
    performed: "./static/images/order_images/rehabilitation_performed.png",
  },
  package_orders: {
    appointment_or_cancel: "./static/images/order_images/package.png",
  },
};

export const UpdateEncounterDetail: Handler = async (controller, params) => {
  const [, error] = await EncounterDetail.update({
    apiToken: controller.apiToken,
    data: {
      action: "OPD_EDIT",
      division: params.division,
      doctor: params.doctor,
      patient: params.patient,
      type: params.type,
    },
    pk: params.encounter,
    extra: {
      division: controller.data.division,
    },
  });

  const state = controller.getState();

  if (error) {
    controller.setState({
      errorMessage: { ...state.errorMessage, [params.card]: error },
    });
  } else {
    controller.handleEvent({
      message: "GetEncounterWithPatient",
      params: { excludeCancel: true, patientId: state.selectedPatient?.id },
    });
  }
};

export const HandleCreateBuyerEncounter: Handler = async(controller, params) => {
  const state = controller.getState();

  controller.setState({
    buttonLoadCheck: { ...state.buttonLoadCheck, [params.btnAction]: "LOADING" },
  });

  const [result, error] = await BuyerEncounterView.post({
    apiToken: controller.apiToken,
    data: { patient: state.selectedPatient?.id },
    extra: { division: controller.data.division },
  });

  if (error) {
    SetErrorMessage(controller, { ...params, error });

    return;
  }

  controller.handleEvent({
    message: "HandleRefreshEncounter",
    params: { encounterId: result.encounter },
  });

  controller.setState({
    buttonLoadCheck: { ...state.buttonLoadCheck, [params.btnAction]: null },
  });

  params.onSuccess?.()
};